import $ from '@vaersaagod/tools/Dom';

export default el => {

    const init = () => {
        $(el).find('a').attr('target', '_blank').attr('rel', 'noopener noreferrer');
    };

    const destroy = () => {};

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/BlankLinks.js